<div class="mask" *ngIf="visible">
  @if (isLoadingScreen) {
    <div
      class="fixed top-0 bottom-0 left-0 right-0 text-center flex justify-content-center align-items-center">
      <i class="fas fa-spinner fa-spin text-8xl text-0"></i>
    </div>
  }
</div>
